import type { Resolution } from '../media-viewer/types';
import type { ResolutionName } from '../utils/transcodes';

type ResolutionMap = {
  [K in Resolution]: K extends 'Auto'
    ? { name: 'Auto' }
    : { name: ResolutionName; value: number };
};

export const resolutionMap: ResolutionMap = {
  h264_2160: {
    name: '2160p',
    value: 2160,
  },
  h264_1080_best: {
    name: '1080p',
    value: 1080,
  },
  h264_720: {
    name: '720p',
    value: 720,
  },
  h264_540: {
    name: '540p',
    value: 540,
  },
  h264_360: {
    name: '360p',
    value: 360,
  },
  Auto: {
    name: 'Auto',
  },
  h265_hdr_2160: {
    name: '2160p HDR',
    value: 2160,
  },
  h265_hdr_1080: {
    name: '1080p HDR',
    value: 1080,
  },
  h265_hdr_720: {
    name: '720p HDR',
    value: 720,
  },
  h265_hdr_540: {
    name: '540p HDR',
    value: 540,
  },
  h265_hdr_360: {
    name: '360p HDR',
    value: 360,
  },
};

export const AUTO = 'Auto';

export const DISABLED_OPACITY = 0.3;

export const PRIMARY_NAV_PANEL_WIDTH = 64;

export const DEFAULT_WORKSPACES_INITIAL_PAGE_COUNT = 100;

export const DELIMITER_REGEXP = /[,;\n\r]/;

export const DELIMITER_REGEXP_WITH_SPACE = /[,;\n\r\s]/;

export const PROJECT_SORT_BY_STORAGE_KEY = 'frame-io--project-sort-by';

export const ESM_ERROR_CODES = {
  NAME_INVALID: 'NAME_INVALID',
  NAME_FORBIDDEN: 'NAME_FORBIDDEN',
  DUPLICATE_NAME: 'DUPLICATE_NAME',
  NAME_LENGTH: 'NAME_LENGTH',
  NAME_RESERVED: 'NAME_RESERVED',
};

export const FAILED = 'FAILED';
